import { compose } from 'recompose';

import SubscribersFilter from './SubscribersFilter';

const enhance = compose();

export default enhance(SubscribersFilter);
